export class ClienteInternacional {
	clienteInternacionalId: number;
	codigoInterno: string;
	razonSocial: string;
	nombreFantasia: string;
	direccionCalle: string;
	direccionNumero: string;
	direccionLineaAdicional: string;
	ciudad: string;
	giro: string;
	direccionEstadoRegion: string;
	paisId: number;
	codigoPais: number;
	activo: boolean;
	emisorId: string;
	correo: string;
	nombrePais: string;
	showActions?: boolean;
}
